import React, { useCallback, useEffect, useState } from "react";
import { ICellRendererParams } from "ag-grid-community";
import { GroupRowInnerRenderer } from "./group-row-inner-renderer";

interface IProps extends ICellRendererParams {
    defaultDateFormat?: string;
}

const containerStyles = {
    display: "flex",
    alignItems: "center",
    height: "100%",
};

const iconStyle = {
    marginRight: "12px",
};

export const TileViewGroupRenderer: React.FunctionComponent<IProps> = (params): any => {
    const { node } = params;
    const [expanded, setExpanded] = useState(node.expanded);

    const toggleExpand = useCallback((): void => {
        node.setExpanded(!node.expanded);
    }, [node]);

    /*
     * FullWidthCellRenderer is not rerendered even though the node.expanded is updated
     * Manually fetch node.expanded in time interval and update the component manually
     */
    useEffect(() => {
        const interval = setInterval(() => {
            setExpanded(node.expanded);
        }, 500);
        return () => {
            clearInterval(interval);
        };
    }, [node.expanded]);

    return (
        <div style={containerStyles} key={node.id}>
            <span
                className={expanded ? "ag-group-expanded" : "ag-group-contracted"}
                style={iconStyle}
                onClick={toggleExpand}
            >
                <span
                    className={`ag-icon ${expanded ? "ag-icon-tree-open" : "ag-icon-tree-closed"}`}
                    unselectable="on"
                ></span>
            </span>

            <GroupRowInnerRenderer {...params} rowIndex={params.rowIndex} />
        </div>
    );
};
